'use client'

import { useState } from 'react'
import { ContentView, resolveContentDocument } from '@/app/richEdit/content'
import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

function plainText(value: string): string {
  return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
}

export function WikiArticleTemplate({ sub, display, controls, slots }: SubTemplateProps) {
  const [expanded, setExpanded] = useState(false)
  const fullHtml = display.permissions.canViewContent && !display.access.isContentLocked && typeof sub.html === 'string'
    ? sub.html
    : ''
  const fullText = plainText(fullHtml)
  const hasMore = fullText.length > display.text.trim().length + 8
  const fullDocument = expanded && fullHtml ? resolveContentDocument({ bodyHtml: fullHtml }) : null

  return (
    <article
      className={`md-wiki-article border-b border-[var(--wiki-border)] bg-[var(--wiki-bg)] py-4${display.isChecked ? ' bg-[var(--wiki-subtle)]' : ''}`}
      data-md-sub-template="wiki"
    >
      <header className="flex min-w-0 items-start gap-3">
        <span className="pt-0.5 [&_.md-sub-icon]:h-5 [&_.md-sub-icon]:w-5">{controls.actions.check}</span>
        <div className="min-w-0 flex-1">
          <h2 className="break-words font-serif text-[22px] font-normal leading-7 text-[var(--wiki-text)] [&_.md-sub-title-link]:text-[var(--wiki-link)] [&_.md-sub-title-link]:no-underline hover:[&_.md-sub-title-link]:underline">
            {controls.content.title}
          </h2>
          <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-[var(--wiki-muted)]">
            {controls.content.time}
            {controls.actions.favorite}
            {controls.actions.quickReply}
          </div>
        </div>
      </header>

      <div className="ml-8 mt-3 break-words text-[15px] leading-7 text-[var(--wiki-text)]">
        {expanded && fullDocument ? <ContentView doc={fullDocument} /> : controls.content.text}
      </div>

      <div className="ml-8 mt-3 flex flex-wrap items-center gap-3 text-sm">
        {hasMore ? (
          <button
            type="button"
            className="font-medium text-[var(--wiki-link)] hover:underline"
            aria-expanded={expanded}
            onClick={() => setExpanded(open => !open)}
          >
            {expanded ? 'Collapse' : 'Expand'}
          </button>
        ) : null}
        {display.href ? <a className="font-medium text-[var(--wiki-link)] hover:underline" href={display.href}>More</a> : null}
        {controls.links.answers}
        {controls.links.submsges}
      </div>

      {slots.allChildren ? <div className="ml-5 mt-4 border-l border-[var(--wiki-border)] pl-4">{slots.allChildren}</div> : null}
    </article>
  )
}
